var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoVbdWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "166px",
    height: "48px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 156.88 45.28",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 16.52,
    y1: 35.49,
    x2: 1.54,
    y2: 5.09
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 1,
    stopColor: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 30.87,
    y1: 12.22,
    x2: 41.65,
    y2: 50.28
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 1,
    stopColor: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id2",
    gradientUnits: "userSpaceOnUse",
    x1: 9.24,
    y1: 14.46,
    x2: 39.98,
    y2: 14.46
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#CA2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 1,
    stopColor: "#B21F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    x1: 40.86,
    y1: 28.23,
    x2: 6.3,
    y2: 37.23
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#CA2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 1,
    stopColor: "#B21F24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 22.64,
    cy: 22.64,
    r: 22.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id0)",
    d: "M9.76 5.26c0,0 -9.89,8.37 -8.1,21.04 0,0 0.32,3.41 3.42,7.62 0,0 3.89,2.78 10.32,2.39 0,0 -11.04,-4.61 -11.12,-16.92 0,0 0.88,13.5 15.49,15.96 0,0 2.3,-0.72 5.72,-3.22 0,0 -9.45,0 -14.38,-6.39 0,0 -8.25,-9.21 -1.35,-20.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id1)",
    d: "M35.5 40c0,0 9.93,-7.39 8.1,-21.05 0,0 -0.31,-3.41 -3.41,-7.62 0,0 -3.89,-2.78 -10.32,-2.38 0,0 11.03,4.6 11.11,16.91 0,0 -0.87,-13.5 -15.48,-15.96 0,0 -2.31,0.72 -5.72,3.22 0,0 9.45,0 14.37,6.39 0,0 8.26,9.21 1.35,20.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id2)",
    d: "M39.98 9.95c0,0 -7.73,-10.17 -21.05,-8.1 0,0 -3.41,0.32 -7.62,3.42 0,0 -2.78,3.89 -2.38,10.32 0,0 4.61,-11.04 16.91,-11.11 0,0 -13.5,0.87 -15.96,15.48 0,0 0.72,2.3 3.22,5.72 0,0 0,-9.45 6.39,-14.38 0,0 9.21,-8.26 20.49,-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id3)",
    d: "M5.56 35.38c0,0 7.39,9.92 21.04,8.1 0,0 3.42,-0.32 7.63,-3.42 0,0 2.78,-3.89 2.38,-10.32 0,0 -4.61,11.04 -16.91,11.12 0,0 13.5,-0.88 15.96,-15.49 0,0 -0.72,-2.3 -3.22,-5.72 0,0 0,9.45 -6.39,14.38 0,0 -9.21,8.26 -20.49,1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A8AB",
    fillRule: "nonzero",
    d: "M16.86 19.54c0.37,0.06 0.67,0.21 0.91,0.47l0 0c0.39,0.42 0.68,0.79 0.86,1.11l4.58 8.2 0.29 -0.04 0.08 -0.01 4.5 -7.78c0.02,-0.03 0.03,-0.05 0.05,-0.08 0.1,-0.16 0.3,-0.41 0.58,-0.72l0 0c0.44,-0.5 0.89,-0.85 1.34,-1.06 0.05,-0.02 0.03,-0.02 0.08,-0.03 0.13,-0.04 0.25,-0.06 0.36,-0.06l0.15 0 0 -0.5 -4.47 0 0 0.5 0.16 0c0.45,0 0.8,0.11 1.05,0.31l0 0c0.25,0.21 0.37,0.46 0.38,0.81 0,0.22 -0.06,0.43 -0.18,0.64l0 0 -3.24 5.55 -3.12 -5.55 0 0c-0.09,-0.17 -0.16,-0.3 -0.21,-0.39 -0.03,-0.07 -0.05,-0.13 -0.06,-0.16l0 0c0.09,-0.34 0.28,-0.62 0.57,-0.85l0 0c0.3,-0.24 0.67,-0.36 1.12,-0.36l0.15 0 0 -0.5 -6.08 0 0 0.48 0.11 0.01c0.01,0.01 0.03,0.01 0.04,0.01zm1.59 0.38c-0.13,-0.14 -0.26,-0.27 -0.4,-0.38l0 0 2.55 0c-0.42,0.38 -0.67,0.76 -0.76,1.18l-0.01 0.02 0.01 0.03c0.03,0.29 0.12,0.55 0.26,0.79l0 0 3.56 6.28 0.01 0.04 0.01 0.07 -0.02 0.08 -0.28 0.48 -4.3 -7.67 0 0c-0.18,-0.32 -0.38,-0.61 -0.59,-0.86 -0.01,-0.02 -0.03,-0.04 -0.04,-0.06zm9.34 -0.38l0.9 0c-0.19,0.29 -0.35,0.53 -0.47,0.71l0 0c-0.09,-0.27 -0.23,-0.51 -0.43,-0.71l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    fillRule: "nonzero",
    d: "M16.61 19.55c0.35,0.06 0.63,0.21 0.87,0.46l0 0c0.39,0.42 0.67,0.79 0.85,1.11l4.58 8.2 0.37 -0.05 4.52 -7.8c0.01,-0.02 0.02,-0.03 0.03,-0.05 0.11,-0.16 0.3,-0.41 0.58,-0.73l0 0c0.45,-0.51 0.9,-0.86 1.35,-1.06 0.14,-0.06 0.28,-0.09 0.44,-0.09l0.15 0 0 -0.5 -4.47 0 0 0.5 0.15 0c0.46,0 0.8,0.11 1.06,0.31l0 0c0.25,0.21 0.37,0.46 0.37,0.81 0,0.22 -0.06,0.43 -0.17,0.64l0 0 -3.24 5.55 -3.12 -5.55 0 0c-0.09,-0.17 -0.16,-0.3 -0.21,-0.39 -0.03,-0.07 -0.05,-0.13 -0.06,-0.16l0 -0.01c0.09,-0.33 0.27,-0.61 0.57,-0.84l0 0c0.3,-0.24 0.66,-0.36 1.11,-0.36l0.16 0 0 -0.5 -6.08 0 0 0.48c0.06,0.01 0.13,0.02 0.19,0.03zm1.54 0.37c-0.12,-0.14 -0.26,-0.27 -0.4,-0.38l2.56 0c-0.42,0.37 -0.68,0.76 -0.77,1.18l0 0.02 0 0.03c0.04,0.29 0.13,0.55 0.27,0.79l0 0 3.55 6.28 0.01 0.04 0.01 0.07 -0.02 0.08 -0.28 0.48 -4.29 -7.67 0 0c-0.19,-0.32 -0.38,-0.61 -0.59,-0.87 -0.02,-0.01 -0.04,-0.03 -0.05,-0.05zm9.35 -0.38l0.9 0c-0.2,0.29 -0.35,0.53 -0.47,0.71 -0.09,-0.27 -0.24,-0.51 -0.43,-0.71l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M59.58 24.91c-0.36,1.11 -0.71,2.16 -0.97,3.23l-0.08 0c-0.26,-1.07 -0.58,-2.14 -0.97,-3.26l-2.37 -6.8 -3.29 0 5.08 12.8 2.92 0 5.21 -12.8 -3.18 0 -2.35 6.83zm29.94 -4.81l0 -2.02 -3.45 0 0 -3.16 -3.03 0.84 0 2.3 -2.89 0c1.22,0.53 1.97,2.04 1.97,2.04l0.92 0 0 6.62c0,1.67 0.34,2.74 1.08,3.44 0.63,0.62 1.66,0.97 2.87,0.97 1.03,0 1.84,-0.11 2.37,-0.3l-0.11 -2.07c-0.37,0.1 -0.73,0.17 -1.34,0.17 -1.29,0 -1.84,-0.77 -1.84,-2.35l0 -6.48 3.45 0 0 0zm49.99 5.53c0,1.79 -1.29,3.32 -3.26,3.32 -2.32,0 -3.58,-1.93 -3.58,-4.44 0,-2.53 1.29,-4.57 3.63,-4.57 1.71,0 3.21,1.23 3.21,3.32l0 2.37 0 0zm3.05 -13.36l-3.05 0 0 7.25 -0.05 0c-0.63,-0.98 -1.97,-1.72 -3.84,-1.72 -3.24,0 -6.06,2.46 -6.06,6.81 0,3.94 2.5,6.52 5.79,6.52 1.86,0 3.33,-0.78 4.16,-1.9l0 1.65 3.05 0 0 -18.61zm-18.65 5.53c-1.94,0 -3.36,0.86 -4.13,1.82l0 -1.54 -3.06 0 0 12.8 3.06 0 0 -7.71c0,-2.05 1.6,-3.14 3.1,-3.14 2.08,0 2.77,1.53 2.77,3.35l0 7.5 3.05 0 0 -7.83c0,-3.95 -2.53,-5.25 -4.79,-5.25zm-11.15 8.76c0,1.48 -1.37,2.6 -3.03,2.6 -1.13,0 -2.13,-0.63 -2.13,-2.04 0,-2.28 2.76,-2.68 5.16,-2.68l0 2.12zm-2.47 -8.76c-1.95,0 -3.66,0.49 -4.69,1.07l0.63 1.79c0.92,-0.54 2.24,-0.88 3.53,-0.88 2.92,0 2.92,1.9 2.92,2.85 -4.97,0 -8.11,1.58 -8.11,4.76 0,1.98 1.56,3.74 4.27,3.74 1.81,0 3.23,-0.74 4.05,-1.74l0.08 0 0 1.49 2.76 0 0 -7.88c0,-2.71 -1.18,-5.2 -5.44,-5.2zm-13.14 11.17c-2,0 -3.31,-1.53 -3.31,-3.15l0 -2.51c0,-1.7 1.42,-3.35 3.34,-3.35 2.42,0 3.6,2.02 3.6,4.44 0,2.74 -1.29,4.57 -3.63,4.57zm-3.31 -16.7l-3.04 0 0 18.61 2.65 0 0 -1.93 0.07 0c0.97,1.51 2.42,2.18 4.29,2.18 3,0 6.08,-2.18 6.08,-6.85 0,-3.9 -2.29,-6.48 -5.61,-6.48 -2.02,0 -3.52,0.77 -4.39,2.07l-0.05 0 0 -7.6zm56.32 16.84c-2.23,0 -3.57,-2.11 -3.57,-4.62 0,-2.21 1,-4.67 3.6,-4.67 2.56,0 3.56,2.51 3.56,4.62 0,2.56 -1.37,4.67 -3.59,4.67zm0.14 -11.31c-3.84,0 -6.85,2.44 -6.85,6.76 0,4.13 2.87,6.57 6.64,6.57 3.26,0 6.79,-1.97 6.79,-6.76 0,-3.92 -2.61,-6.57 -6.58,-6.57zm-77.27 5.37c0.16,-1.49 1.11,-3.44 3.34,-3.44 2.34,0 3.05,1.9 3.03,3.44l-6.37 0zm3.55 -5.37c-4.1,0 -6.53,3.04 -6.53,6.85 0,3.91 2.53,6.48 6.9,6.48 1.97,0 3.58,-0.34 4.61,-0.76l-0.5 -1.91c-0.95,0.35 -2.06,0.61 -3.66,0.61 -2.29,0 -4.32,-1.09 -4.4,-3.97l9.21 0c0.06,-0.33 0.08,-0.7 0.08,-1.14 0,-3.16 -1.63,-6.16 -5.71,-6.16zm-10.52 13.08l3.05 0 0 -12.82 -3.05 0 0 12.82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVbdWhite);
export default __webpack_public_path__ + "static/media/logo-vbd-white.6f541b6af0c1818eccf92cb1f31808d9.svg";
export { ForwardRef as ReactComponent };